<script>
export default {
  functional: true,

  props: {
    priceText: { type: String, required: true },
    priceInterval: { type: String, default: null },
    preheader: { type: String, default: null },
    subText: { type: String, default: null }
  },

  render(h, { props }) {
    return (
      <div class="cta-row-price p-relative pl-1 mr-1">
        {props.preheader && (
          <span class="cta-row-price__preheader text-x-small opacity-60">
            {props.preheader}
          </span>
        )}
        <h3 class="m-0">
          {props.priceText}
          {props.priceInterval && (
            <span
              class="cta-row-price__interval"
              domPropsInnerHTML={` ${props.priceInterval
                .split(" ")
                .join("&nbsp")}`}
            ></span>
          )}
        </h3>
        {props.subText && (
          <span class="text-x-small opacity-60">{props.subText}</span>
        )}
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.cta-row-price__preheader {
  display: inline-block;
  margin-bottom: 4px;
}

.cta-row-price__interval {
  font-weight: $font-weight--base;
  font-size: $font-size--small;
}

.cta-row-price {
  top: 2px;

  h3 {
    line-height: 1rem;
  }
}
</style>
